import { ROUTE_PATH } from "common/constants/sm-constants";
import { FormMetaModel, SmMetaInputModel, SmBtnMetaModel } from "common/models/utility-models/meta-model";

export class LocationMetaModel extends FormMetaModel {
    constructor() {
        super('Add location', ROUTE_PATH.locationGrid, ROUTE_PATH.locationAdd, 3, '', false, '', ' align-items-center justify-content-center');
    }

    override initProperties(): any {
        const formInfo = super.initProperties();
        const city_name = new SmMetaInputModel(
            'city_name',
            'city_name',
            'input',
            true,
            'col-6',
            1,
            1,
            'Name',
            'text',
            '',
            false,
            true,
            true,
            false,
            100,
            1
        );
        

        const buttons = {
            submit: new SmBtnMetaModel('SUBMIT', '', true, false, true, true),
            isFormControl: false
        };


        return {
            formInfo,
            buttons,
            city_name,
        }
    }
}